export default __webpack_public_path__ + "static/settings-dark-604e0ba03d865fb4accd6059f0849cca.png";